export enum PromiseSettledResultStatus {
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
}
